import React, { useState } from "react";
import { Layout, Menu, Breadcrumb } from "antd";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const {Content, Sider } = Layout;

const graphs = [
  {
    id: "graph1",
    title: "Evolución en el tiempo",
    menuTitle: "Evolución en el tiempo",
    text: `Desde 2015, se ha mantenido relativamente constante la proporción de estudiantes de 4º básico que no tiene las habilidades mínimas en matemáticas. Esto con la excepción del año 2022, primera medición después de la pandemia, donde la proporción de estudiantes con puntajes insuficientes aumentó a un 45%. En el año 2023 se volvió a cifras similares a los años pre pandemia y en 2024 la proporción de estudiantes con estándares insuficientes disminuyó a un 34%. En 2025 la proporción de insuficientes aumentó levemente a un 36%. La misma tendencia ocurre con la proporción de estudiantes que obtienen un nivel adecuado de conocimientos: desde 2015 es estable, pero en 2022 se observó una baja importante. En 2025, la proporción se ubica en el último año en un 26% de estudiantes con conocimientos adecuados.`,
    link: "https://public.flourish.studio/visualisation/20888593/embed",
  },
  {
    id: "graph2",
    title: "Análisis por sexo",
    menuTitle: "\u2022 Sexo",
    text: `Desde 2016, los niños han obtenido mejores puntajes en la prueba Simce de Matemáticas en comparación con las niñas. Al observar cómo ha evolucionado esta brecha, se observa que, a partir de 2022, se ha profundizado la diferencia entre niñas y niños. En 2025, existen 11 puntos porcentuales entre la proporción de niñas y niños que obtienen puntajes adecuados. 

  Por otra parte, de 2024 a 2025, la proporción de niñas que no alcanzan los conocimientos mínimos aumentó en 3 puntos, mientras que la proporción de niños lo hizo en 1.`,
    link: "https://public.flourish.studio/visualisation/20888560/embed",
  },
  {
    id: "graph3",
    title: "Análisis por dependencia administrativa",
    menuTitle: "\u2022 Dependencia",
    text: `El desempeño en la prueba de matemáticas está marcado por la dependencia administrativa de los colegios. Existen desigualdades claras: mientras que en 2025 el 42% de las y los estudiantes de colegios públicos no alcanzan las competencias mínimas, esta proporción es de 36%  en colegios subvencionados y de 13% en los colegios particulares. En cuanto a un nivel adecuado de competencias, sólo el 20% de las y los alumnos de colegios públicos lo alcanza, en comparación con el 24% de colegios subvencionados y el 52% de colegios particulares pagados.

  Respecto a la trayectoria en el desempeño, tanto para los colegios públicos, como los subvencionados y los particulares pagados existe una tendencia similar: alcanzaron su peor rendimiento en 2022, primera medición post pandemia, luego desde 2023 a 2024 mejoraron su desempeño y en 2025 muestran un leve empeoramiento.`,
    link: "https://public.flourish.studio/visualisation/20888516/embed",
  },
  {
    id: "graph4",
    title: "Análisis por zona de residencia",
    menuTitle: "\u2022 Zona",
    text: `Las y los estudiantes que asisten a establecimientos educacionales en zonas urbanas tienen en promedio un mejor desempeño que aquellos que van a colegios en zonas rurales. Desde 2022, la brecha entre ambos grupos de estudiantes ha tendido a disminuir levemente, pero niñas y niños de zonas rurales continúan obteniendo peores resultados. En 2025, mientras que un 35% de las niñas y niños residentes de zonas urbanas presentan conocimientos insuficientes, un 43% de estudiantes rurales lo hace.`,
    link: "https://public.flourish.studio/visualisation/20888546/embed",
  },
  {
    id: "graph5",
    title: "Análisis por región",
    menuTitle: "\u2022 Región",
    text: `Existen diferencias territoriales en el desempeño en la prueba Simce de matemáticas. Las regiones con mejor desempeño, de acuerdo a la proporción de estudiantes que tienen un nivel adecuado de conocimientos, son la región de Ñuble, Maule y Metropolitana, con un 29% cada una. A su vez, las regiones con peor desempeño, es decir, con mayor proporción de estudiantes sin los conocimientos mínimos, son Tarapacá (46%), Atacama (44%) y Valparaíso (41%).`,
    link: "https://public.flourish.studio/visualisation/23712585/embed",
  }
];


const App = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState("graph1");

  const handleMenuItemClick = (graphId, graphTitle) => {
    setSelectedMenuItem(graphId);
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const selectedGraph = graphs.find((graph) => graph.id === selectedMenuItem);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        width={250}
        collapsible
        collapsed={collapsed}
        onCollapse={toggleCollapsed}
        style={{ background: "#fff" }}
        breakpoint="lg"
        collapsedWidth={0}
      >
        <Menu theme="dark" mode="vertical" selectedKeys={[selectedMenuItem]} style={{ background: "#fff" }}>
          {graphs.map((graph) => (
            <Menu.Item
            key={graph.id}
            onClick={() => handleMenuItemClick(graph.id)}
            style={{ color: 'black', paddingLeft: graph.id !== "graph1" ? "30px" : "20px" }}
          >
            {graph.menuTitle}
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Layout style={{ padding: "24px 24px 24px" }}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item></Breadcrumb.Item>
        </Breadcrumb>
        <Content
          id="content"
          style={{
            background: "#ffff",
            padding: 24,
            margin: 0,
            minHeight: 280,
          }}
        >
          {selectedGraph && (
            <div>
              <div style={{ marginBottom: 16 }}>
                <h1>{selectedGraph.title}</h1>
              </div>
              <div style={{ textAlign: 'justify' }}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {selectedGraph.text}
                </ReactMarkdown>
              </div>
              <iframe
                src={selectedGraph.link}
                frameBorder="0"
                scrolling="no"
                style={{ minWidth: "100%", height: "500px" }}
              ></iframe>
            </div>
          )}
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;
